import { render, staticRenderFns } from "./user_grzx_ls.vue?vue&type=template&id=54af3b0e&scoped=true"
import script from "./user_grzx_ls.vue?vue&type=script&lang=js"
export * from "./user_grzx_ls.vue?vue&type=script&lang=js"
import style0 from "./user_grzx_ls.vue?vue&type=style&index=0&id=54af3b0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af3b0e",
  null
  
)

export default component.exports